import { useUserQuery } from "@/hooks/use-user";
import type { GettingStarted, GettingStartedStep, User } from "@/types/user";

// Order matters: it is the order the checklist is worked through.
export const GETTING_STARTED_STEPS: readonly GettingStartedStep[] = [
  "script_installed",
  "device_added",
  "notification_sent",
  "widget_added",
];

export const countDoneSteps = (progress: GettingStarted) =>
  GETTING_STARTED_STEPS.filter((step) => progress[step]).length;

export const isGettingStartedDone = (progress: GettingStarted) =>
  countDoneSteps(progress) === GETTING_STARTED_STEPS.length;

interface UseGettingStartedQueryOptions {
  pollInterval?: number;
}

export const useGettingStartedQuery = ({
  pollInterval,
}: UseGettingStartedQueryOptions = {}) =>
  useUserQuery({
    select: (user: User) => user.getting_started,
    // Keeps polling through a failed refetch while progress is on screen;
    // only a first load that failed stops it, and the page offers a retry.
    refetchInterval: (query) => {
      const user = query.state.data;
      if (!pollInterval || (user && isGettingStartedDone(user.getting_started))) {
        return false;
      }
      return user || query.state.status !== "error" ? pollInterval : false;
    },
  });
